"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var degrees_1 = require("../constants/degrees");
function getBrightness(_a) {
    var r = _a.r, g = _a.g, b = _a.b;
    // http://alienryderflex.com/hsp.html
    var brightness = Math.sqrt((degrees_1.R_DEGREE * r * r) +
        (degrees_1.G_DEGREE * g * g) +
        (degrees_1.B_DEGREE * b * b));
    return brightness;
}
exports.default = getBrightness;
